/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-use-before-define */
/**
 * Content Fragment List
 */
import { Component, registerComponent } from 'js/component.js';
import { isEditModeFooter } from 'js/helpers.js';

const componentName = 'cookie-popup';

class CookiePopup extends Component {

    /**
     * Component Setup
     */

    // Elements
    elements = {
        container: this.element.querySelector(`.${componentName}__container`),
        acceptButton: this.element.querySelector(`.${componentName}__button-accept`),
        cancelButton: this.element.querySelector(`.${componentName}__button-cancel`),
        closeButton: this.element.querySelector(`.${componentName}__close`),
        privacyText: this.element.querySelector(`.${componentName}__privacy-text`),
        link: this.element.querySelector(`.${componentName}__link`),
    };

    closePopup = () => {
        this.element.classList.remove('active');
        document.body.classList.remove('no-scroll');
    };

    /**
     * Add Event Listeners
     */
    addEventListeners = () => {
        // Accept Button
        this.elements.acceptButton.addEventListener('click', this.closePopup);
        this.elements.acceptButton.addEventListener('keydown', (event) => {
            if (event.key === 'Enter') {
                this.closePopup();
            }
        });

        // Cancel Button
        this.elements.cancelButton.addEventListener('click', this.closePopup);
        this.elements.cancelButton.addEventListener('keydown', (event) => {
            if (event.key === 'Enter') {
                this.closePopup();
            }
        });

        // Close Button
        this.elements.closeButton.addEventListener('click', this.closePopup);
        this.elements.closeButton.addEventListener('keydown', (event) => {
            if (event.key === 'Enter') {
                this.closePopup();
            }
        });
    };

    updatePrivacyText = () => {
        // Replace double whitespace with link element
        const text = this.elements.privacyText.innerHTML;
        const linkHtml = this.elements.link.outerHTML;
        const newText = text.replace(linkHtml, '').replace('{0}', linkHtml);
        this.elements.privacyText.innerHTML = newText;
    };

    /**
     * Initialize Component
     */
    init() {
        this.updatePrivacyText();

        // Fire Init Funcs
        if (!isEditModeFooter()) {
            this.addEventListeners();
        }
    }
}

registerComponent(`.${componentName}`, CookiePopup);
